var render = function render(){
  var _vm$debtLabel, _vm$payload;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('modal-close-button', {
    attrs: {
      "aria-label": "Zavrieť výdavok"
    },
    on: {
      "click": _vm.closePopup
    }
  }), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v(" " + _vm._s((_vm$debtLabel = _vm.debtLabel) === null || _vm$debtLabel === void 0 ? void 0 : _vm$debtLabel.toLowerCase()) + " ")]), _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "outcome-submit"
    }
  }, [_vm._v("Uložiť")])], 1), _vm.clientInfo ? _c('div', {
    staticClass: "header-block inline"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.clientInfo.type))]), _c('img', {
    staticClass: "image-10",
    attrs: {
      "src": _vm.getIcon(_vm.clientInfo.type),
      "loading": "lazy",
      "alt": ""
    }
  })]) : _vm._e(), (_vm$payload = _vm.payload) !== null && _vm$payload !== void 0 && _vm$payload.error ? _c('div', {
    staticClass: "header-block-error"
  }, [_vm._v("Nutné opraviť: "), _vm._l(_vm.payload.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text font-size-12"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e(), _c('div', [_vm.type.debtPurpose === 'refinancovane' && this.$store.getters['mortgageDetailState/getCoApplicant'] ? _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'clientDebt',
      "init-value": _vm.refinancedClient,
      "options": _vm.debtClient,
      "normal": "",
      "name": 'Dlh klienta'
    },
    on: {
      "select": function select($event) {
        _vm.refinancedClient = $event;
      }
    }
  })], 1) : _vm._e(), _c(_vm.activeComponent, {
    tag: "component",
    attrs: {
      "debt": _vm.payload,
      "banks": _vm.banks
    },
    on: {
      "debt-saved": function debtSaved($event) {
        return _vm.saveDebt($event);
      }
    }
  }), _c('div', {
    staticClass: "modalBottomWrapper"
  }, [_vm.cloud && _vm.cloud.missingFiles.length > 0 ? _c('div', _vm._l(_vm.cloud.missingFiles, function (missingFile, index) {
    return _c('document-cloud-handler', {
      key: index,
      attrs: {
        "title": missingFile.name,
        "type": missingFile.id,
        "uploaded": missingFile.uploaded,
        "class-cst": 'upload-item-broker-custom',
        "cloud-meta": _vm.cloud.cloudMeta,
        "rules": ['single'],
        "text-button": ""
      }
    });
  }), 1) : _vm._e(), _vm.type.debtType === 'hypoteka' ? _c('div', {
    staticClass: "sub-popup-wrapper"
  }, [_c('client-property-handler', {
    attrs: {
      "rules": ['single'],
      "type": 'zatazene_nehnutelnosti',
      "client-type": _vm.clientInfo,
      "title": 'priradiť zaťaženú NEHNUTEĽNOSŤ',
      "properties-selected": _vm.foundedPropertiesIds
    }
  })], 1) : _vm._e(), _vm._l(_vm.foundedProperties, function (property, key) {
    return _c('div', {
      key: key,
      staticClass: "input-block contrast p-relative"
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.removeProperty(key);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "div-block-101"
    }, [_vm._v(" " + _vm._s(_vm.getAddressModified(property)) + " "), _c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(property.hodnota) + " EUR")])])]);
  })], 2)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }